import React, { useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import styled from "styled-components";
import Footer from "../Components/Footer";
import Nav from "../Components/Nav";
import emailjs from "@emailjs/browser";

function Contact() {
  const form = useRef();
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_ui1zv9l",
        "template_74qtqzi",
        form.current,
        "dhWq6M73klRpSL5RC"
      )
      .then(
        () => {
          setSent(true);
        },
        () => {
          setError(true);
        }
      );
  };

  return (
    <>
      <Nav />
      <Section>
        {sent ? (
          <SuccessContainer>
            <Success>
              <h3>Message sent!</h3>
              <p>Thank you for reaching out. I'll get back to you shortly.</p>
            </Success>
          </SuccessContainer>
        ) : (
          <>
            <motion.div
              className="page"
              key="index"
              exit={{ width: "100%", transition: { duration: 1 } }}
            ></motion.div>
            <AnimatePresence>
              <Start
                animate={{
                  left: "auto",
                  right: 0,
                  width: "0",
                  transition: { duration: 0.5 },
                }}
              ></Start>
            </AnimatePresence>
            <div
              className="side-label"
              style={{
                position: "fixed",
                transform: "rotate(-90deg)",
                top: "50%",
                left: "50px",
                margin: "auto",
              }}
            >
              <Overflow style={{ position: "relative", marginBottom: "60px" }}>
                <RevealBar
                  initial={{
                    width: "0%",
                    top: 0,
                    height: "100%",
                    position: "absolute",
                  }}
                  whileInView={{ width: "100%", x: ["0%", "0%", "0%", "100%"] }}
                  transition={{ duration: 1 }}
                  viewport={{ once: true }}
                />
                <Side
                  initial={{ y: 10 }}
                  whileInView={{ y: 0 }}
                  transition={{ delay: 1, transition: 1 }}
                  viewport={{ once: true }}
                >
                  CONTACT
                </Side>
              </Overflow>
            </div>
            <Container>
              <div style={{ paddingTop: "150px" }}>
                <Overflow
                  style={{ position: "relative", marginBottom: "40px" }}
                >
                  <RevealBar
                    initial={{
                      width: "0%",
                      top: 0,
                      height: "100%",
                      position: "absolute",
                    }}
                    whileInView={{
                      width: "100%",
                      x: ["0%", "0%", "0%", "100%"],
                    }}
                    transition={{ duration: 1 }}
                    viewport={{ once: true }}
                  />
                  <H2
                    initial={{ y: "100%" }}
                    whileInView={{ y: 0 }}
                    transition={{ delay: 1, duration: 0.6 }}
                    viewport={{ once: true }}
                  >
                    Get in touch.
                  </H2>
                </Overflow>
                <Overflow style={{ marginBottom: "80px", width: "100%" }}>
                  <P
                    initial={{ y: "100%" }}
                    whileInView={{ y: 0 }}
                    transition={{ delay: 1, duration: 0.6 }}
                    viewport={{ once: true }}
                  >
                    Have a project in mind or just want to say hello? Drop me a
                    message I read every email and respond promptly.
                  </P>
                </Overflow>
              </div>
              <motion.form
                ref={form}
                onSubmit={sendEmail}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ delay: 1, transition: 1 }}
                viewport={{ once: true }}
              >
                <Label>Your Name</Label>
                <Input type="text" name="user_name" required />
                <Label>Your Email</Label>
                <Input type="email" name="user_email" required />
                <Label>Message</Label>
                <Textarea required name="subject" rows={6} />
                {error && (
                  <ErrorMsg>
                    Something went wrong. Please try again or email me at
                    savadn632@gmail.com
                  </ErrorMsg>
                )}
                <Anchor type="submit">
                  Send Message
                  <svg width="30" height="18" viewBox="0 0 10 6" fill="none">
                    <path
                      d="M6.71627 0L6.27434 0.441934L8.14928 2.31688H0V2.94189H8.14922L6.27434 4.81678L6.71627 5.25871L9.34566 2.62936L6.71627 0Z"
                      fill="currentColor"
                    />
                  </svg>
                </Anchor>
              </motion.form>
            </Container>
          </>
        )}
      </Section>
      <Footer />
    </>
  );
}

export default Contact;

const SuccessContainer = styled(motion.div)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

const Success = styled(motion.div)`
  text-align: center;
  margin: auto;
  border: 1px solid var(--border);
  padding: 50px 60px;
  width: fit-content;
  border-radius: 4px;

  h3 {
    font-size: 28px;
    margin-bottom: 12px;
  }
  p {
    font-size: 16px;
    color: var(--text-4);
  }
`;

const Section = styled(motion.div)`
  position: relative;
  min-height: 100vh;
  margin-bottom: 100px;
  transition: background-color 0.3s ease, color 0.3s ease;
`;

const Container = styled(motion.div)`
  max-width: 1200px;
  margin: auto;
  padding: 0 20px;
  transition: background-color 0.3s ease, color 0.3s ease;

  @media (max-width: 1430px) {
    padding: 0 30px;
  }
`;

const Start = styled(motion.div)`
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  background-color: var(--overlay);
  z-index: 999;
  overflow-x: hidden;
`;

const Overflow = styled(motion.div)`
  overflow: hidden;
  width: fit-content;
  position: relative;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const H2 = styled(motion.h2)`
  font-size: 56px;
  line-height: 64px;
  letter-spacing: -1px;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 36px;
    line-height: 44px;
  }
`;

const P = styled(motion.p)`
  font-size: 18px;
  line-height: 30px;
  color: var(--text-3);
  max-width: 600px;
`;

const Label = styled(motion.h5)`
  font-size: 13px;
  font-weight: 500;
  margin-top: 36px;
  margin-bottom: 8px;
  letter-spacing: 1px;
  color: var(--text-5);
  text-transform: uppercase;
`;

const Input = styled(motion.input)`
  font-size: 18px;
  line-height: 30px;
  width: 100%;
  height: 56px;
  border: 0;
  border-bottom: 1px solid var(--border-form);
  outline: none;
  background: transparent;
  transition: border-color 0.3s ease;
  &:focus {
    border-bottom-color: var(--text);
  }
`;

const Textarea = styled.textarea`
  font-size: 18px;
  line-height: 28px;
  width: 100%;
  border: 0;
  border-bottom: 1px solid var(--border-form);
  outline: none;
  background: transparent;
  resize: none;
  font-family: inherit;
  margin-top: 4px;
  transition: border-color 0.3s ease;
  &:focus {
    border-bottom-color: var(--text);
  }
`;

const ErrorMsg = styled.p`
  color: #c0392b;
  font-size: 14px;
  margin-top: 20px;
`;

const Side = styled(motion.h4)`
  font-size: 12px;
  line-height: 10px;
  font-weight: 400;
`;

const RevealBar = styled(motion.div)`
  background: var(--overlay);
  transition: background 0.3s ease;
`;

const Anchor = styled(motion.button)`
  text-decoration: none;
  font-size: 18px;
  text-transform: capitalize;
  position: relative;
  background: none;
  border: none;
  outline: none;
  color: var(--text);
  margin-top: 60px;
  display: flex;
  align-items: center;
  padding: 20px 40px;
  z-index: 1;
  width: fit-content;
  gap: 20px;
  cursor: pointer;

  &::after {
    position: absolute;
    content: "";
    width: 50px;
    height: 50px;
    background: var(--btn-bg);
    z-index: -1;
    display: block;
    left: 0px;
    top: 0;
    bottom: 0;
    transition: 0.8s ease;
    border-radius: 50%;
  }
  &:hover::after {
    border-radius: 30px;
    width: 100%;
    height: 100%;
  }
`;
